import React, { useState, useEffect, useContext } from 'react';
import { MenuContext } from 'src/context/MenuContext';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { getMcode } from "src/store/mcode";
import Header from 'src/components/common/Header';
import UserTable from 'src/components/user/UserTable';
import { getUsers } from "src/store/user";
import { getUserProfiles } from "src/store/profile";
import Menu from 'src/components/common/Menu';
import ScrollTop from 'src/components/common/ScrollTop';
import { useAuth } from 'src/hooks/useAuth';
import CustomLoader from 'src/components/common/CustomLoader';
import { ValidationMessages } from 'src/components/common/ValidationMessage';

const UserList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const mcode = useSelector((state) => state.mcode.data);
  const [validationMessages, setValidationMessages] = useState([]);
  const [cd, setCd] = useState('');
  const { user: userData } = useAuth();
  const [loading, setLoading] = useState(true);

  const userinput = () => {
    if (userData.auth_cd === '1') {
      navigate('/userInput');
    } else {
      navigate('/userList');
    }

  };

  useEffect(() => {
    setLoading(true); // Set loading to true before dispatch
    dispatch(getUsers({ status_cd: cd })).then((res) => {
      if (res.payload) {
        setLoading(false); // Set loading to false if the request is successful
      }
      if (res.error) {
        setValidationMessages(res.error.message); // Set loading to false if the request is successful
      }
    });
  }, [dispatch, cd]);

  useEffect(() => {
    dispatch(getUserProfiles()).then((res) => {
      if (res.payload) {
        setLoading(false); // Set loading to false if the request is successful
      }
      if (res.error) {
        setValidationMessages(res.error.message); // Set loading to false if the request is successful
      }
    });
  }, []);


  useEffect(() => {
    dispatch(getMcode({ section_cd: 'status,auth,workinghourscd,bloodgroup,programminglanguage' }));
  }, []);

  // Destructuring correctly from menuContext
  const { visibleMenu } = useContext(MenuContext);

  return (
    <>
      {visibleMenu && <Menu />}
      <div className={visibleMenu ? 'menu-open' : 'menu-closed'}>
        <Header sx={{ mb: 500 }} />
        <div id="client_list">
          {validationMessages && validationMessages.length > 0 && (
              <div style={{ background: "#ffe4e2" }}>
                  <ValidationMessages
                      messages={validationMessages}
                      onClose={() => setValidationMessages([])}
                  />
              </div>
          )}
          <section className="container-fluid contents-top">
            <div className="text-center">
              <h1>
                User List ({user.total}People)&nbsp;
                {(userData.auth_cd === '1') &&(<button  type="button" className="btn btn-default" onClick={userinput}>
                  <span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
                </button>)}
              </h1>
            </div>
          </section>
          {loading ? <CustomLoader /> :
            <section className="container">
              <div>
                <UserTable users={user.data} cd={cd} setCd={setCd} mcode={mcode}/>
              </div>
            </section>}
        </div>
      </div>
      <ScrollTop />
    </>
  );
};

export default UserList;
